import React from 'react';

import PnPreviewCard from 'components/formulas/previews/pnPreviewCard';
import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';

import { FormulaDetailModel } from 'models/formula.model';

export type ContentTabProps = {
    data: FormulaDetailModel;
};
const ContentTab: React.FC<ContentTabProps> = ({ data }) => {
    return (
        <ContentContainer>
            <PnPreviewCard formulaStructure={data.structure} formula={data} />
        </ContentContainer>
    );
};
export default ContentTab;

const ContentContainer = styled.div({
    padding: aampeTheme.spacing4(5),
});
